import {Component, EventEmitter} from '@angular/core';
import {ModalComponent} from '../modal-service.service';

@Component({
    selector: 'nlr-information-modal',
    imports: [],
    templateUrl: './information-modal.component.html',
    styleUrls: ['../modal.scss', './information-modal.component.scss']
})
export class InformationModalComponent implements ModalComponent {
    modalClosed: EventEmitter<string> = new EventEmitter();
    modalSize: string = 'modal-md';

    closeDialog() {
        this.modalClosed.emit('Close dialog');
    }
}
